import { Text } from '@dixa/lib-shared-habla';
import { ConversationAutomationThirdPartyIntegrationLogEntry } from 'lib-shared-types-api';

type RoutedThroughThirdPartyIntegrationProps = {
  node: ConversationAutomationThirdPartyIntegrationLogEntry;
};
export function RoutedThroughThirdPartyIntegration({
  node,
}: RoutedThroughThirdPartyIntegrationProps): JSX.Element {
  if (node.outcome.type === 'error') {
    return (
      <Text.Paragraph>
        Integration · Failed with error: {node.outcome.message}
      </Text.Paragraph>
    );
  }

  return (
    <Text.Paragraph>
      Integration · Successfully called the integration
    </Text.Paragraph>
  );
}
